// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import variantApi from '~/apis/variant';
import { IQueryParamVariant } from '~/utils/interface/variant';
import { DELETE_VARIANT, GET_LIST_VARIANT } from '~/utils/constants/actionType';

export const getListVariant = createAsyncThunk(
  GET_LIST_VARIANT,
  async (params: IQueryParamVariant, { rejectWithValue }) => {
    try {
      const resp = await variantApi.getListVariant(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteVariant = createAsyncThunk(DELETE_VARIANT, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await variantApi.deleteVariant(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
